import { createContext, type ReactNode, useContext } from "react";
import { useWebSocket, type WebSocketHookType } from "../hooks/use-websocket";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type WebSocketContextType<T = any, O = any> = WebSocketHookType<T, O>;

export const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useWebSocketContext = <T = any, O = any>() => {
  return useContext(WebSocketContext) as WebSocketContextType<T, O>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WebSocketProvider = <T = any, O = any>({
  children,
  path,
  onMessageCallback,
  useAuth = true,
  queryParams = {},
}: {
  children: ReactNode;
  path: string;
  onMessageCallback?: (message: O) => void;
  useAuth?: boolean;
  queryParams?: Record<string, string>;
}) => {
  const resp = useWebSocket<T, O>(path, onMessageCallback, useAuth, queryParams);

  return <WebSocketContext.Provider value={resp}>{children}</WebSocketContext.Provider>;
};
